/**
 * The landing screen: what Spottr is, before anything is asked of the device.
 *
 * The app used to open with a camera permission prompt on a dark page. A
 * browser permission dialog is the most expensive thing an app can ask for and
 * the page behind it was saying nothing about who was asking or why, which is
 * the one situation where "Block" is the sensible answer. So the camera is not
 * touched until someone has read a blurb and pressed a button.
 *
 * The press is also a real user gesture, which the camera prefers: a
 * `getUserMedia` out of a tap is treated more kindly than one fired on load,
 * and on iOS it is the difference between a prompt the athlete was expecting
 * and one that arrives while the page is still blank. (The audio context is
 * unlocked separately, on Start — see audio.js.)
 */
export class Intro {
  constructor() {
    this.root = document.getElementById("intro");
    this.start = document.getElementById("intro-start");
  }

  /**
   * Shows the screen and resolves when the athlete proceeds. Nothing after
   * this in startup runs until then — that is the whole point of it.
   */
  wait() {
    this.root.hidden = false;
    // The panel rather than the button: a dialog that opens needs focus inside
    // it to be announced, and focusing the button instead paints the amber ring
    // on a phone that has no keyboard to have asked for it. Tab from here
    // reaches the button first.
    this.root.focus({ preventScroll: true });
    return new Promise((resolve) => {
      this.start.addEventListener(
        "click",
        () => {
          this.root.hidden = true;
          resolve();
        },
        { once: true }
      );
    });
  }
}
